import axios from "axios";
//import store from "@/store";
//import { Message } from "element-plus";
//import router from "@/router";
// import { md5SignEncode } from '@/utils/index'
const service = axios.create({
  //baseURL: process.env.VUE_APP_URL,
  baseURL: "https://api.gstsr.com",
});
service.interceptors.request.use(
  (config) => {
    config.headers["Accept-Language"] = sessionStorage.getItem("theLanguage")
      ? sessionStorage.getItem("theLanguage")
      : "zh-CN";
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    const access_token = localStorage.getItem('access_token')
    config.headers["Authorization"] = `bearer ${
      access_token ? access_token : ""
    }`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  (res) => {
    // 统一错误处理
    //if (res.data.code !== 200 && res.data.code !== 10102 && res.data.code !== 10101) {
      //Message.error(res.data.msg);
      //return Promise.reject(res.data.msg);
    //}
    return res;
  },
  (error) => {
    // 接口报错
    //Message.error(error.response || error.response.data.msg);
    return Promise.reject(error.response.data.msg);
  }
);

export default service;
